import { USER_STATUS } from 'constants/status';

const notEditableFields: string[] = [
  USER_STATUS.kycSubmitted,
  USER_STATUS.kycInReview,
  USER_STATUS.kycApproved,
  USER_STATUS.kycDeclined,
  USER_STATUS.idvNotStarted,
  USER_STATUS.idvSubmitted,
  USER_STATUS.idvInReview,
  USER_STATUS.idvApproved,
  USER_STATUS.idvDeclined,
  USER_STATUS.active,
  USER_STATUS.accountProcessing,
  USER_STATUS.accountCreationFailed,
];

export const disabledField = (profileStatus?: string): boolean =>
  notEditableFields.includes(profileStatus ?? '');

export const disabledEmail = (profileStatus: string): boolean =>
  profileStatus !== USER_STATUS.draft;

export const disabledNextBillingDate = (profileStatus: string): boolean =>
  profileStatus !== USER_STATUS.active;

export const disabledCustodian = (profileStatus: string): boolean =>
  [...notEditableFields, USER_STATUS.accepted].includes(profileStatus);
